import React, { useEffect, useState, useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';
// import { EyeFilled, EyeInvisibleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { useValidateEB } from 'all-in-one-shared-api';
import { Alert, Button, Card, Form, Input } from 'antd';
import StyledCheckbox from '../components/StyledCheckbox';
import eyeOpen from 'assets/images/Mask.svg';
import eyeClose from 'assets/images/redMask.svg';
import styled from 'styled-components';
import { Wrapper } from 'pages/life/forget/styledComponents';
import { Typography } from 'antd';
// import regIcon from 'assets/images/register-icon.svg';
// import { RegistrationFlowContext } from 'contexts/registration';
// import { RegistrationFormData } from 'contexts/registration/registrationFormData';
import { useRegistrationStateQuery } from 'hooks/useRegistrationStateQuery';
import { VerifyEmail, setErrorCodeFun } from 'utils';
import { MobileNumberPrefix } from 'components';
// import { IconTitle } from 'components';
import PolicyAndMemberIdModal from '../../forget/PolicyAndMemberIdModal';
// import { revalidateAntdFormLanguageChanged } from '../../../../i18n';
import { StyledTitle } from 'components/StyledTitle';
import ProgressSteps from '../components/ProgressSteps';
import { AgreementCheckbox } from '../components/AgreeCheckbox';
// import _get from 'lodash/get';
import './EbCreate.less';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
import { NamePath } from 'rc-field-form/es/interface';

export interface EbUserResponse {
  personalEmail: string;
  sharedEmail: string;
}
export type FormData = {
  loginId?: string;
  password?: string;
  email?: string;
  confirmPassword?: string;
  mobile?: string;
  countryCode?: string;
};
const RegistrationCard = styled(Card)`
  width: 100%;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
`;

const FormWrapper = styled.div`
  display: grid;
  row-gap: 12px;
  max-width: 510px;
`;

function EbCreateProfile() {
  const [password, setPassword] = useState('');
  // const [ApiError, setApiError] = useState<string | null>(null);
  const { t, i18n } = useTranslation();
  const initialValues = useRegistrationStateQuery();
  const [visible, setVisible] = useState(false);
  // const [registrationState, setRegistrationState] = useState<RegistrationFormData>(initialValues);
  // const { state, dispatch } = useContext(RegistrationFlowContext);
  // const [setMobilePrefix] = useState(initialValues.countryCode || defaultPrefix);
  const navigate = useNavigate();
  const [form] = Form.useForm();
  // const [snackbarMessage, setSnackbarMessage] = useState(initialValues.registerError || '');
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [visible2, setVisible2] = useState(false);
  // const emailRef = React.useRef<InputRef>(null);
  const handleToggleVisibility = () => {
    setVisible(!visible);
  };
  const handleToggleVisibility2 = () => {
    setVisible2(!visible2);
  };
  const [form1, setForm1] = useState((): FormData => {
    return {
      loginId: '',
      password: '',
      email: '',
      confirmPassword: '',
      mobile: '',
      countryCode: '+852',
    };
  });
  const [randoms, setRandoms] = useState(0);
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState(false);
  const [validateEbError, setValidateEbError] = useState('');
  const [errors, setErrors] = useState<string | null>(null);
  const [errorsmsg, setErrorsmsg] = useState<string>('');
  // const dob = registrationState.dob ?? '';
  const location = useLocation() as {
    state: {
      policyNumber: string;
      memberId: string;
      birthDate: string;
      memberType: '0';
      ValidateEbData: EbUserResponse;
      registNum?: boolean;
      // 第三方
      loginId?: string;
      password?: string;
      confirmPassword?: string;
      email?: string;
      outLink?: boolean;
      mobile?: string;
      countryCode: string;
    };
  };

  /* eslint-disable */
  useEffect(() => {
    return () => {
      ValidateEBShouldFetch(false);
    };
  }, []);
  useEffect(() => {
    if (location.state.loginId) {
      form.setFieldValue('loginId', location.state.loginId);
    }
    if (location.state.password) {
      form.setFieldValue('password', location.state.password);
      setForm1({
        ...form1,
        password: location.state.password,
      });
      setPassword(location.state.password);
    }
    if (location.state.confirmPassword) {
      form.setFieldValue('confirmPassword', location.state.confirmPassword);
      setForm1({
        ...form1,
        confirmPassword: location.state.confirmPassword,
      });
    }
    if (location.state.email) {
      form.setFieldValue('email', location.state.email);
    }
    setForm1({
      ...form,
      loginId: location.state.loginId,
      password: location.state.password,
      confirmPassword: location.state.confirmPassword,
      email: location.state.email,
      mobile: location.state.mobile,
      countryCode: location.state.countryCode ?? '',
    });
  }, [location]);
  useEffect(() => {
    // setCode(false);
    setLoading(true);
    console.log(loading);
    getInfo();
  }, [location]);
  /* eslint-disable */
  const getInfo = () => {
    if (!location.state.ValidateEbData?.personalEmail && !location.state.ValidateEbData?.sharedEmail) {
      setEmail(true);
      setLoading(false);
    }
    if (location.state.ValidateEbData?.personalEmail && !location.state.ValidateEbData?.sharedEmail) {
      setEmail(false);
      setLoading(false);
    }
    if (!location.state.ValidateEbData?.personalEmail && location.state.ValidateEbData?.sharedEmail) {
      setEmail(true);
      setLoading(false);
    }
    // setEmail(true);
  };
  const {
    shouldFetch: ValidateEBShouldFetch,
    data: ValidateEBData,
    // mutate: ValidateEBMutate,
    error: ValidateEBError,
    isLoading,
  } = useValidateEB(
    'useForgetLoginId' + randoms,
    location.state.policyNumber,
    location.state.memberId,
    location.state.birthDate,
    form1?.loginId ? form1.loginId : '',
    form1.password ?? '',
    i18n.language,
    location.state.memberType,
    form1?.countryCode ?? '',
    form1?.email ?? '',
    form1?.mobile ?? '',
  );
  /* eslint-disable */
  useEffect(() => {
    if (ValidateEBData && ValidateEBData.success) {
      ValidateEBShouldFetch(false);
      navigate('/register/otp-verification', {
        state: {
          selfDefinedLoginId: form1.loginId,
          password: form1.password,
          policyNumber: location.state.policyNumber,
          memberType: location.state.memberType,
          dob: location.state.birthDate,
          email: form1.email,
          type: 'eb',
          loginId: form1.loginId,
          pwd: form1.password,
          birthDate: location.state.birthDate,
          memberId: location.state.memberId,
          registNum: location.state.registNum,
          countryCode: form1.countryCode,
          mobile: form1.mobile,
        },
      });
    }
    if (ValidateEBError?.code) {
      ValidateEBShouldFetch(false);
      setErrors(ValidateEBError.code);
      setErrorsmsg(ValidateEBError.message);
      const message = setErrorCodeFun(ValidateEBError.code, i18n.language);
      setValidateEbError(message ?? ValidateEBError?.message);
    }
    if (i18n.language && errors) {
      const message = setErrorCodeFun(errors, i18n.language);
      setValidateEbError(message ?? errorsmsg);
    }
  }, [ValidateEBData, ValidateEBError, i18n.language, errors, errorsmsg]);
  /* eslint-disable */
  const handleCloseSnackbar = () => {
    setValidateEbError('');
  };
  useEffect(() => {
    if (errors || errorsmsg) {
      const message = setErrorCodeFun(errors as string, i18n.language);
      setValidateEbError(message ?? errorsmsg);
    }
  }, [i18n.language, form]);

  const onValidateSuccessful = (event?: React.BaseSyntheticEvent) => {
    event && event.preventDefault();
    setRandoms(Math.random());
    ValidateEBShouldFetch(true);
  };
  useEffect(() => {
    let name: NamePath[] | undefined = [];
    form.getFieldsError().forEach((d) => {
      if (d.errors.length && d.name) {
        name = name?.concat(d.name);
      }
    });
    console.log(form.getFieldsError(), 'form.getFieldsError()');

    if (form.getFieldsError().some((errors) => errors.errors.length)) {
      form.validateFields(name);
    }
  }, [i18n.language]);
  const onFinish = (values: FormData) => {
    setErrors(null);
    setErrorsmsg('');
    setValidateEbError('');
    console.log(location.state.ValidateEbData, 'onFinish====');
    console.log(values, '================');
    setForm1({
      ...form1,
      loginId: values.loginId?.trim(),
      password: password,
      email: email ? values.email : location.state.ValidateEbData.personalEmail,
    });
    onValidateSuccessful();
  };
  const closeModel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    console.log('Current password value:', password);
  }, [password]);
  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log('e', e.target.value);
    setPassword(e.target.value);
  };
  const [checks, setChecks] = useState(false);
  const onChange = (val: boolean) => {
    setChecks(val);
  };
  const handleChange = useCallback(
    (value: string, form11) => {
      setForm1({
        ...form11,
        countryCode: value,
      });
      // form.setFieldsValue({
      //   countryCode: value,
      // });
      // dispatch({ type: ActionType.SubmitForm, payload: { ...state, countryCode: value } });
      // eslint-disable-line react-hooks/exhaustive-deps
    },
    [form],
  );
  useEffect(() => {
    handleChange('+852', form1);
    // eslint-disable-line react-hooks/exhaustive-deps
  }, [handleChange]);
  return (
    <div className="eb_create_wrapper">
      {/* <IconTitle title={t('launch.registerBtn')} level={2} icon={regIcon} /> */}
      <RegistrationCard
        style={{
          width: '100%',
          backgroundColor: 'white',
          borderRadius: '0',
        }}
      >
        <div className="step_wrapper">
          <ProgressSteps activeStepIndex={1} />
          <div
            className="title"
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              fontFamily: 'Roboto400',
              fontSize: '26px',
            }}
          >
            <StyledTitle level={5} type="secondary" margin="24px 0 24px 0">
              {t('registration.createProfileTitle')}
            </StyledTitle>
          </div>
        </div>

        <Wrapper style={{ backgroundColor: 'white', borderRadius: 0, border: 0, padding: 0 }}>
          <Form
            className="form_wrapper"
            initialValues={initialValues}
            layout={'vertical'}
            requiredMark={false}
            onFinish={onFinish}
            onFinishFailed={() => {
              setErrors(null);
              setErrorsmsg('');
              setValidateEbError('');
            }}
            form={form}
            validateTrigger={false}
            style={{ width: '100%' }}
          >
            {email && (
              <div className={'connectEBRemind'}>
                <StyledTitle level={5} type="secondary">
                  {t('registration.EB.connectEBRemind')}
                </StyledTitle>
              </div>
            )}
            <div
              className={email ? 'wrapper' : 'no_email_wrapper'}
              style={{
                display: 'flex',
                flexDirection: 'row',
                // alignItems: 'center',
                justifyContent: 'space-around',
                width: '100%',
              }}
            >
              <div
                className={email ? 'left_noemail' : 'left_email'}
                style={{ flex: 1, borderRight: email ? '1px solid #CCCCCC' : 'none', padding: '0 64px !important' }}
              >
                {!email && (
                  <div className={'connectEBRemind'}>
                    <StyledTitle level={5} type="secondary">
                      {t('registration.EB.connectEBRemind')}
                    </StyledTitle>
                  </div>
                )}
                {email && (
                  <StyledTitle
                    level={5}
                    type="secondary"
                    style={{ fontFamily: 'Roboto400', fontSize: 22, fontWeight: 'normal', color: '#6F7072' }}
                  >
                    {t('registration.EB.stepTitle1')}
                  </StyledTitle>
                )}

                <StyledTitle
                  className="secondary"
                  level={5}
                  type="secondary"
                  style={{
                    height: '54px',
                    lineHeight: '54px',
                    fontFamily: 'Roboto400',
                    fontSize: 17,
                    color: '#752127',
                  }}
                >
                  {t('forgetPassword.mandatoryMsg')}
                </StyledTitle>

                <FormWrapper className="eb_create_form">
                  <Form.Item
                    label={t('registration.EB.loginId')}
                    name="loginId"
                    className="loginId"
                    rules={[
                      { required: true, message: t('registration.error.required') },
                      {
                        validator: (_, value) => {
                          const trimmedValue = value?.trim();
                          // 验证最大长度和最小长度
                          if (trimmedValue && (trimmedValue.length > 20 || trimmedValue.length < 6)) {
                            return Promise.reject(new Error(t('registration.error.invalidLoginId')));
                          }

                          // 使用正则表达式验证
                          const loginIdRegex = /^[a-zA-Z0-9_]+$/; // 假设这是 loginIdRegex 的正则表达式
                          if (!loginIdRegex.test(trimmedValue)) {
                            return Promise.reject(new Error(t('registration.error.invalidLoginId')));
                          }

                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input
                      size="middle"
                      maxLength={20}
                      onChange={(e) => {
                        setForm1({
                          ...form1,
                          loginId: e.target.value?.trim(),
                        });
                      }}
                      disabled={
                        initialValues.isEmailRegister ||
                        (location.state.outLink && location.state.loginId ? true : false)
                      }
                      placeholder={t('registration.EB.loginIdHolder')}
                      style={{
                        border: 'none',
                        borderBottom: '1px solid #E5E5E5',
                        // color: "white",
                        backgroundColor: 'transparent',
                      }}
                    />
                  </Form.Item>
                  <StyledTitle level={5} style={{ fontSize: '17px', color: '#B0B2B3' }} type="secondary">
                    {t('registration.EB.loginIdvalidation')}
                  </StyledTitle>
                  {/* <Form.Item
                    className="confirmPassword"
                    label={t('registration.EB.passwordTitle')}
                    name="password"
                    // rules={[
                    //   { required: true, message: t('registration.error.required') },
                    //   () => ({
                    //     validator(_, value) {
                    //       console.log('value', value, 'getFieldValue', password);
                    //       if (!value || password === value) {
                    //         return Promise.resolve();
                    //       }
                    //       return Promise.reject(new Error(t('registration.error.invalidConfirmPassword')));
                    //     },
                    //   }),
                    // ]}
                  >
                    <Input
                      size="middle"
                      maxLength={12}
                      disabled={initialValues.isEmailRegister}
                      placeholder={t('registration.EB.passwordHolder')}
                      style={{
                        border: 'none',
                        borderBottom: '1px solid #E5E5E5',
                        // color: "white",
                        backgroundColor: 'transparent',
                      }}
                      onChange={handlePasswordChange}
                    />
                    <div style={{ marginTop: 16 }}>
                      <div>
                        <StyledCheckbox
                          checked={password?.length >= 8 && /[a-zA-Z]/.test(password) && /\d/.test(password)}
                        >
                          <Typography.Text style={{ fontSize: '17px', color: '#B0B2B3' }}>
                            {t('registration.EB.passwordValidation1')}
                          </Typography.Text>
                        </StyledCheckbox>
                      </div>
                      <div>
                        <StyledCheckbox checked={/[A-Z]/.test(password) && /[a-z]/.test(password)}>
                          <Typography.Text style={{ fontSize: '17px', color: '#B0B2B3' }}>
                            {t('registration.EB.passwordValidation2')}
                          </Typography.Text>
                        </StyledCheckbox>
                      </div>
                      <div>
                        <StyledCheckbox checked={/\d/.test(password)}>
                          <Typography.Text style={{ fontSize: '17px', color: '#B0B2B3' }}>
                            {t('registration.EB.passwordValidation3')}
                          </Typography.Text>
                        </StyledCheckbox>
                      </div>
                    </div>
                  </Form.Item> */}
                  {/* <Form.Item
                    label={t('registration.confirmLabel') + '*'}
                    name="confirmPassword"
                    className="confirmPassword"
                    dependencies={['password']}
                    rules={[
                      { required: true, message: t('registration.error.required') },
                      () => ({
                        validator(_, value) {
                          console.log('value', value, 'getFieldValue', password);
                          if (!value || password === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error(t('registration.error.invalidConfirmPassword')));
                        },
                      }),
                    ]}
                  >
                    <Input
                      size="middle"
                      maxLength={12}
                      disabled={initialValues.isEmailRegister}
                      placeholder={t('resetPassword.confirmPasswordPlaceholder')}
                      style={{
                        border: 'none',
                        borderBottom: '1px solid #E5E5E5',
                        // color: "white",
                        backgroundColor: 'transparent',
                      }}
                    />
                  </Form.Item> */}
                  <BoldLabelFormItem
                    label={
                      <span
                        style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}
                      >
                        {t('registration.EB.passwordTitle')}
                      </span>
                    }
                    name="password"
                    // rules={[
                    //   { required: true, message: t("registration.error.required") },
                    //   {
                    //     validator: (rule, value) => {
                    //       if (value.length < 8 || value.length > 12) {
                    //         return Promise.reject(
                    //           new Error(t("registration.error.passwordLength"))
                    //         );
                    //       }
                    //       if (!/[a-zA-Z]/.test(value) || !/\d/.test(value)) {
                    //         return Promise.reject(
                    //           new Error(t("registration.error.passwordValidation1"))
                    //         );
                    //       }
                    //       if (!/[A-Z]/.test(value) || !/[a-z]/.test(value)) {
                    //         return Promise.reject(
                    //           new Error(t("registration.error.passwordValidation2"))
                    //         );
                    //       }
                    //       return Promise.resolve();
                    //     },
                    //   },
                    // ]}
                  >
                    <div style={{ position: 'relative' }}>
                      <Input
                        size="middle"
                        maxLength={12}
                        // disabled={initialValues.isEmailRegister}
                        placeholder={t('registration.EB.passwordHolder')}
                        style={{
                          border: 'none',
                          borderBottom: '1px solid #E5E5E5',
                          // color: "white",
                          backgroundColor: 'transparent',
                        }}
                        value={password}
                        disabled={location.state.outLink && location.state.password ? true : false}
                        onChange={handlePasswordChange}
                        type={visible ? 'text' : 'password'}
                        // placeholder={placeholder}
                      />
                      <img
                        src={visible ? eyeOpen : eyeClose}
                        alt="toggle visibility"
                        style={{ cursor: 'pointer', width: 20, height: 20, position: 'absolute', top: 10, right: 4 }}
                        onClick={handleToggleVisibility}
                      />
                    </div>
                    <div style={{ marginTop: 20 }}>
                      <div>
                        <StyledCheckbox
                          checked={password?.length >= 8 && /[a-zA-Z]/.test(password) && /\d/.test(password)}
                        >
                          <Typography.Text
                            style={{
                              marginTop: 16,
                              fontFamily: 'Roboto400',
                              fontSize: 17,
                              color: '#B0B2B3',
                              fontWeight: 'normal',
                            }}
                          >
                            {t('registration.EB.passwordValidation1')}
                          </Typography.Text>
                        </StyledCheckbox>
                      </div>
                      <div>
                        <StyledCheckbox checked={/[A-Z]/.test(password) && /[a-z]/.test(password)}>
                          <Typography.Text
                            style={{
                              marginTop: 16,
                              fontFamily: 'Roboto400',
                              fontSize: 17,
                              color: '#B0B2B3',
                              fontWeight: 'normal',
                            }}
                          >
                            {t('registration.EB.passwordValidation2')}
                          </Typography.Text>
                        </StyledCheckbox>
                      </div>
                      <div>
                        <StyledCheckbox checked={/\d/.test(password)}>
                          <Typography.Text
                            style={{
                              marginTop: 16,
                              fontFamily: 'Roboto400',
                              fontSize: 17,
                              color: '#B0B2B3',
                              fontWeight: 'normal',
                            }}
                          >
                            {t('registration.EB.passwordValidation3')}
                          </Typography.Text>
                        </StyledCheckbox>
                      </div>
                    </div>
                  </BoldLabelFormItem>
                  <BoldLabelFormItem
                    label={
                      <span
                        style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}
                      >
                        {t('registration.confirmLabel') + '*'}
                      </span>
                    }
                    name="confirmPassword"
                    dependencies={['password']}
                    rules={[
                      { required: true, message: t('registration.error.required') },
                      () => ({
                        validator(_, value) {
                          console.log('value', value, 'getFieldValue', password);
                          if (!value || password === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error(t('registration.error.invalidConfirmPassword')));
                        },
                      }),
                    ]}
                  >
                    <div style={{ position: 'relative' }}>
                      <Input
                        size="middle"
                        maxLength={12}
                        // disabled={initialValues.isEmailRegister}
                        placeholder={t('registration.EB.confirmPswHolder')}
                        value={form1.confirmPassword}
                        disabled={location.state.outLink && location.state.confirmPassword ? true : false}
                        onChange={(val) =>
                          setForm1({
                            ...form1,
                            confirmPassword: val.target.value,
                          })
                        }
                        style={{
                          border: 'none',
                          borderBottom: '1px solid #E5E5E5',
                          // color: "white",
                          backgroundColor: 'transparent',
                        }}
                        type={visible2 ? 'text' : 'password'}
                        // placeholder={placeholder}
                      />
                      <img
                        src={visible2 ? eyeOpen : eyeClose}
                        alt="toggle visibility"
                        style={{ cursor: 'pointer', width: 20, height: 20, position: 'absolute', top: 10, right: 4 }}
                        onClick={handleToggleVisibility2}
                      />
                    </div>
                  </BoldLabelFormItem>
                </FormWrapper>
              </div>
              {email && <div className="driver_email" />}
              {email && (
                <div className="right_email" style={{ width: '50%' }}>
                  <StyledTitle
                    level={5}
                    type="secondary"
                    style={{ fontFamily: 'Roboto400', fontSize: 22, fontWeight: 'normal', color: '#6F7072' }}
                  >
                    {t('registration.EB.contactDetails')}
                  </StyledTitle>
                  <StyledTitle
                    level={5}
                    className="secondary"
                    type="secondary"
                    style={{
                      fontFamily: 'Roboto500',
                      fontSize: 20,
                      fontWeight: 'normal',
                      height: '98px',
                      display: 'flex',
                      alignItems: 'center',
                      // color: 'rgba(0, 0, 0, 0.45)',./
                    }}
                  >
                    {t('registration.EB.verification')}
                  </StyledTitle>
                  <Form.Item
                    label={t('life.forgetLoginId.Emailaddress')}
                    name="email"
                    // required
                    rules={[
                      // { required: true, message: t('registration.error.required') },
                      {
                        required: !form1.email && !form1.mobile ? true : false,
                        message: t('registration.error.required'),
                      },
                      {
                        validator: (_, value) => {
                          if (value && !VerifyEmail(value)) {
                            return Promise.reject(new Error(t('registration.error.invalidEmail')));
                          }
                          // else if (!value) {
                          //   return Promise.reject(new Error(t('registration.error.required')));
                          // }

                          return Promise.resolve();
                        },
                      },
                    ]}
                    style={{ marginBottom: 12 }}
                  >
                    <Input
                      size="middle"
                      style={{
                        border: 'none',
                        borderBottom: '1px solid #E5E5E5',
                        // color: "white",
                        backgroundColor: 'transparent',
                      }}
                      // disabled={location.state.outLink && location.state.email ? true : false}
                      onChange={(e) => {
                        setForm1({
                          ...form1,
                          email: e.target.value,
                        });
                      }}
                      placeholder={t('life.forgetLoginId.yourEmail')}
                    />
                  </Form.Item>
                  <div
                    className="orMsg"
                    style={{
                      height: '66px',
                      lineHeight: '66px',
                      paddingLeft: 20,
                    }}
                  >
                    <Typography.Text type="secondary">{t('life.forgetLoginId.OR')}</Typography.Text>
                  </div>
                  <Form.Item
                    label={t('life.forgetLoginId.MobileNumber')}
                    name="mobileFiled"
                    // required
                    className="mobile"
                    style={{
                      marginBottom: 12,
                      display: 'flex',
                      flexDirection: 'row',
                    }}
                  >
                    <Form.Item name="countryCode">
                      <MobileNumberPrefix defaultValue="+852" handleChange={(val) => handleChange(val, form1)} />
                    </Form.Item>
                    <Form.Item
                      name="mobile"
                      rules={[
                        {
                          required: !form1.email && !form1.mobile ? true : false,
                          message: t('registration.error.required'),
                        },
                        {
                          validator: (_, value) => {
                            console.log(form1.countryCode, 'countryCode===========');
                            console.log(value, 'mobile===========');
                            if (value && form1.countryCode) {
                              if (form1.countryCode.trim() == '852' || form1.countryCode.trim() == '+852') {
                                return new RegExp('^[4-9][\\d]{7}$').test(value)
                                  ? Promise.resolve()
                                  : Promise.reject(new Error(t('registration.error.mobileValid')));
                              } else {
                                return new RegExp('^[\\d]{8,13}$').test(value)
                                  ? Promise.resolve()
                                  : Promise.reject(new Error(t('registration.error.invalidMobile')));
                              }
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Input
                        onChange={(val) => {
                          setForm1({
                            ...form1,
                            mobile: val.target.value,
                          });
                        }}
                        size="middle"
                        style={{
                          border: 'none',
                          borderBottom: '1px solid #E5E5E5',
                          backgroundColor: 'transparent',
                        }}
                        placeholder={t('life.forgetLoginId.PhoneNumber')}
                      />
                    </Form.Item>
                  </Form.Item>
                </div>
              )}
            </div>

            <div className={email ? 'check_wrapper' : 'check_wrapper_no_eamil'}>
              <AgreementCheckbox
                childrens={
                  <Trans i18nKey="common.termNPolicy">
                    {[
                      <a
                        style={{ textDecoration: 'underline', fontFamily: 'Roboto400', fontSize: 17 }}
                        key="termsNConditions"
                        href={t('settings.legalInformationLink')}
                        // to={`/terms-and-conditions?lan=${i18n.language}`}
                        target="_blank"
                        rel="noreferrer"
                      />,
                      <a
                        style={{ textDecoration: 'underline', fontFamily: 'Roboto400', fontSize: 17 }}
                        key="privacyPolicy"
                        href={t('settings.privacySecurityCookiesLink')}
                        // to={`/privacy-policy?lan=${i18n.language}`}
                        target="_blank"
                        rel="noreferrer"
                      />,
                      <a
                        key="personalInfoCollectionDoc"
                        href={t('settings.privacyPolicyLink')}
                        target="_blank"
                        rel="noreferrer"
                        style={{ textDecoration: 'underline', fontFamily: 'Roboto400', fontSize: 17 }}
                      />,
                    ]}
                  </Trans>
                }
                onChange={(e) => onChange(e.target.checked)}
              />
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                marginTop: 20,
                paddingBottom: 20,
              }}
            >
              {validateEbError && (
                <Alert
                  className="btn_error"
                  message={validateEbError}
                  type="error"
                  // closable
                  onClose={handleCloseSnackbar}
                  style={{ marginBottom: 0 }}
                />
              )}
              <Form.Item
                className="form_btn"
                // style={{
                //   width: '70%',
                // }}
              >
                <Button
                  className="btn"
                  block
                  type="primary"
                  loading={isLoading}
                  size="large"
                  disabled={
                    !checks ||
                    !form1.confirmPassword ||
                    !form1.loginId ||
                    !password ||
                    (email ? !form1.email && !form1.mobile : false)
                  }
                  htmlType="submit"
                  style={{ fontFamily: 'Roboto500', fontSize: 20 }}
                >
                  {t('common.next')}
                </Button>
              </Form.Item>
              <Link
                style={{
                  fontWeight: 'normal',
                  marginLeft: 4,
                  marginRight: 4,
                  color: '#C21A17',
                  textDecoration: 'underline',
                  fontFamily: 'Roboto400',
                  fontSize: 17,
                }}
                to="/login"
              >
                {t('common.cancel')}
              </Link>
            </div>
          </Form>
        </Wrapper>
      </RegistrationCard>
      <PolicyAndMemberIdModal isModalVisible={isModalVisible} handleModalClose={closeModel} />
    </div>
  );
}

export default EbCreateProfile;
